<template lang="pug">
feathers-vuex-get(service="dashboard" :id="sequence" :query="{}" :fetchQuery="queryParameter" watch="fetchQuery")
    div(slot-scope="{ item: DashboardDesserts, isGetPending }")
        h2 Dashboard
        v-divider
        div(style="padding-top: 10px; font-size: 16px; font-weight: bold;")
            center(v-if="dateFilters.isUpdated") Report from "{{ queryParameter.dateRanged[0] }}" to "{{ queryParameter.dateRanged[1] }}"
        div(v-if="isGetPending")
            v-progress-linear(color="primary" :size="70" :width="7" indeterminate)
        br
        v-row(v-if="!isGetPending && DashboardDesserts")
            v-col(cols="12" sm="12" md="6" lg="3" xl="3")
                v-card(color="#2196F3" dark)
                    .d-flex.flex-no-wrap.justify-space-between
                        div
                            v-card-text TOTAL USERS
                                br
                                h1 {{ DashboardDesserts.totalUsers[0] }}
                            v-card-actions
                                v-icon mdi-menu-up
                                b {{ DashboardDesserts.totalUsers[1] | avarage(DashboardDesserts.totalUsers[0]) }}
                                | &nbsp;Last week

                        v-avatar.ma-3(tile)
                            v-icon(size="45") mdi-account-box-multiple
            
            v-col(cols="12" sm="12" md="6" lg="3" xl="3")
                v-card(color="#1DE9B6" dark)
                    .d-flex.flex-no-wrap.justify-space-between
                        div
                            v-card-text NEW USERS
                                br
                                h1 {{ DashboardDesserts.newUsers[0] }}
                            v-card-actions
                                v-icon mdi-menu-{{ DashboardDesserts.newUsers[1] }}
                                | &nbsp;Today

                        v-avatar.ma-3(tile)
                            v-icon(size="45") mdi-account-box

            v-col(cols="12" sm="12" md="6" lg="3" xl="3")
                v-card(color="#90A4AE" dark)
                    .d-flex.flex-no-wrap.justify-space-between
                        div
                            v-card-text SONG ADDED
                                br
                                h1 {{ DashboardDesserts.songAdded[0] }}
                            v-card-actions
                                v-icon mdi-menu-{{ DashboardDesserts.songAdded[1] }}
                                | &nbsp;Today

                        v-avatar.ma-3(tile)
                            v-icon(size="45") mdi-music-note-plus
            
            v-col(cols="12" sm="12" md="6" lg="3" xl="3")
                v-card(color="#00B8D4" dark)
                    .d-flex.flex-no-wrap.justify-space-between
                        div
                            v-card-text SONG RATED
                                br
                                h1 {{ DashboardDesserts.songRated[0] }}
                            v-card-actions
                                v-icon mdi-menu-{{ DashboardDesserts.songRated[1] }}
                                | &nbsp;Today

                        v-avatar.ma-3(tile)
                            v-icon(size="45") mdi-star

        br(v-if="!isGetPending && DashboardDesserts")
        v-row(v-if="!isGetPending && DashboardDesserts")
            v-col(cols="12" sm="12" md="12" lg="8" xl="8")
                v-card
                    v-card-title
                        v-icon(small) mdi-home-analytics
                        .text-overline(style="flex: 1;") &nbsp;Analytics
                        div
                            filter-dialog-vue(v-model="dateFilters")
                    v-divider
                    line-chart(:chart-data="dataCollection(DashboardDesserts.chart, dateFilters.isUpdated ? DashboardDesserts.newUsers[0] : DashboardDesserts.totalUsers[0])" :options="chartOptions" style="height: 357px;")
            v-col(cols="12" sm="12" md="12" lg="4" xl="4")
                v-card
                    v-card-title
                        v-icon(small) mdi-account-multiple
                        .text-overline &nbsp;New Users
                    v-divider
                    v-list(dense)
                        template(v-for="(item, index) in reverseData(DashboardDesserts.newUsersLists)")
                            //- v-subheader Test
                            v-divider(v-if="index !== 0")
                            v-list-item
                                v-list-item-avatar
                                    v-img(:src="item.profile_picture")
                                v-list-item-content
                                    v-list-item-title {{ item.name }}
                                    v-list-item-subtitle {{ item.email }}
                                v-list-item-action
                                    v-chip(v-if="item.status === 1" small color="green" dark) {{ item.status | status }}
                                    v-chip(v-else small color="grey" dark) {{ item.status | status }}

        v-row(v-if="!isGetPending && DashboardDesserts")
            v-col(cols="12")
                v-card
                    v-card-title
                        v-icon(small) mdi-account-multiple
                        .text-overline &nbsp;Label Campaign
                        v-spacer
                        v-btn(color="primary" dark @click="$router.push('/label-campaign-manager')")
                            v-icon(small left) mdi-pencil
                            | Manage
                    v-divider
                    v-simple-table
                        template(v-slot:default)
                            thead
                                tr
                                    th Song name
                                    th Date Added
                            tbody
                                tr(v-for="(item, index) in DashboardDesserts.labelCampaign")
                                    td
                                        v-avatar(size="40" tile)
                                            v-img(:src="item.music_cover_thumb")
                                        | &nbsp;&nbsp;&nbsp;
                                        a(:href="`https://www.breakinghits.app/${item.user.result.url}`" :target="`__user-${item.id}`" v-html="item.title")
                                    td
                                        v-chip(small color="green" outlined) {{ item.date_added | date }}

</template>

<script>
import LineChart from './components/LineChart';
import moment from 'moment';
import FilterDialogVue from './components/FilterDialog.vue';

export default {
    data() {
        return {
            dateFilters: {
                isUpdated: false,
                dateRangeString: '1 Month',
                dateRange: [moment().subtract(1, 'years').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                userType: 0
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                hover: {
                    mode: 'index',
                    intersect: false
                },
                elements: {
                    point:{
                        radius: 0
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            maxTicksLimit: 6,
                            beginAtZero: false,
                            display: true,
                        },
                            gridLines: {
                            drawBorder: false,
                            showBorder: false,
                            display: true,
                        },
                    }],
                    xAxes: [{
                        gridLines: {
                            drawBorder: false,
                            showBorder: false,
                            display: true,
                        },
                        ticks: {
                            display: true,
                            maxTicksLimit: 4
                        }
                    }]
                }
            }
        };
    },
    filters: {
        avarage(value, total) {
            return (value / total).toFixed(4) + '%';
        },
        status(v) {
            switch(v) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
            return 'Unknown';
        },
        date(v) {
            return moment(v).format('lll');
        }
    },
    computed: {
        queryParameter() {
            if(this.dateFilters.isUpdated) {
                return { dateRanged: this.dateFilters.dateRange };
            }
            return {};
        },
        sequence() {
            return parseInt(((new Date()) / 1000).toFixed(0));
        }
    },
    components: {
        LineChart,
        FilterDialogVue
    },
    methods: {
        dataCollection(chart, total) {
            const d = [...chart].reverse();
            let adjust = total - d.reduce((o, i) => {
                return o + i.value;
            }, 0);
            return this.datacollection = {
                labels: d.map(i => {
                    return moment(i.date, "YYYY-MM-DD").format('MMM Do');
                }),
                datasets: [
                    {
                        label: 'Followers',
                        borderColor: '#42A5F5',
                        data: d.map(i => adjust += i.value),
                        tension: 0.1
                    }
                ]
            };
        },
        reverseData(data) {
            return [...data].reverse();
        }
    }
}
</script>